
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDButton from 'components/MDButton';
import MDInput from "components/MDInput";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TextField } from "@mui/material";
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import * as moment from 'moment';
import * as service from '../../services/service';

function SponsorshipWorkOrder() {
    const [state, setState] = useState({
        outwardnumber: '', inwardnumber: '', workordernumber: '', proposalfilename: '', proposalfilepath: '',
        approvalfilename: '', approvalfilepath: '', workorderfilename: '', workorderfilepath: '',
        deliverable1: '', deliverable2: '', deliverable3: '', deliverable4: '', deliverable5: '',
        deliverable6: '', deliverable7: '', deliverable8: '', deliverable9: '', deliverable10: '', sponsorshipamount: '',
        financialinwardnumber: '', financialapprovalfilename: '', financialapprovalfilepath: '', revisedsponsorshipamount: '',
        revisionfilename: '', revisionfilepath: '', hamipatrafilename: '', hamipatrafilepath: '',
        deliverable1filename: '', deliverable1filepath: '', deliverable2filename: '', deliverable2filepath: '', deliverable3filename: '', deliverable3filepath: '',
        deliverable4filename: '', deliverable4filepath: '', deliverable5filename: '', deliverable5filepath: '', deliverable6filename: '', deliverable6filepath: '',
        deliverable7filename: '', deliverable7filepath: '', deliverable8filename: '', deliverable8filepath: '', deliverable9filename: '', deliverable9filepath: '',
        deliverable10filename: '', deliverable10filepath: '', completionfilename: '', completionfilepath: '', nastinumber: ''
    });
    const [data, setData] = useState([{}]);
    const [proposalFile, setProposalFile] = useState('');
    const [approvalFile, setApprovalFile] = useState('');
    const [financialApprovalFile, setFinancialApprovalFile] = useState('');
    const [workOrderFile, setWorkOrderFile] = useState('');
    const [revisionFile, setRevisionFile] = useState('');
    const [hamipatraFile, setHamipatraFile] = useState('');
    const [deliverable1File, setDeliverable1File] = useState('');
    const [deliverable2File, setDeliverable2File] = useState('');
    const [deliverable3File, setDeliverable3File] = useState('');
    const [deliverable4File, setDeliverable4File] = useState('');
    const [deliverable5File, setDeliverable5File] = useState('');
    const [deliverable6File, setDeliverable6File] = useState('');
    const [deliverable7File, setDeliverable7File] = useState('');
    const [deliverable8File, setDeliverable8File] = useState('');
    const [deliverable9File, setDeliverable9File] = useState('');
    const [deliverable10File, setDeliverable10File] = useState('');
    const [completionFile, setCompletionFile] = useState('');
    const [presentationStatus, setPresentationStatus] = useState('');
    const [presentationDate, setPresentationDate] = useState(new Date());
    const [proposalDate, setProposalDate] = useState(new Date());
    const [approvalDate, setApprovalDate] = useState(new Date());
    const [financialApprovalDate, setFinancialApprovalDate] = useState(new Date());
    const [workOrderDate, setWorkOrderDate] = useState(new Date());
    const [revisionDate, setRevisionDate] = useState(new Date());
    const [deliverable1Status, setDeliverable1Status] = useState('');
    const [deliverable2Status, setDeliverable2Status] = useState('');
    const [deliverable3Status, setDeliverable3Status] = useState('');
    const [deliverable4Status, setDeliverable4Status] = useState('');
    const [deliverable5Status, setDeliverable5Status] = useState('');
    const [deliverable6Status, setDeliverable6Status] = useState('');
    const [deliverable7Status, setDeliverable7Status] = useState('');
    const [deliverable8Status, setDeliverable8Status] = useState('');
    const [deliverable9Status, setDeliverable9Status] = useState('');
    const [deliverable10Status, setDeliverable10Status] = useState('');
    const presentationStatusData = [{ value: 'Pending', label: 'Pending' }, { value: 'Done', label: 'Done' },
    { value: 'Cancelled', label: 'Cancelled' }, { value: 'Not Applicable', label: 'Not Applicable' }];
    const deliverableStatusData = [{ value: 'Pending', label: 'Pending' }, { value: 'Yes', label: 'Yes' }, { value: 'No', label: 'No' }];

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const params = useParams();

    const getRegistrationById = () => {
        setLoading(true);
        // const errs = {};        
        if (params.id > 0) {
            fetch(
                service.GET_SPONSROSHIP_BY_ID,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                    },
                    body: JSON.stringify({
                        SponsorshipId: params.id,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.message.messageType === 'Success') {
                        setData(result);

                        setState({
                            ...state, workordernumber: result.workOrderNo, outwardnumber: result.outwardNo,
                            inwardnumber: result.inwardNo, financialinwardnumber: result.financialInwardNo,
                            proposalfilename: result.proposalFileName, proposalfilepath: result.proposalFilePath,
                            approvalfilename: result.approvalFileName, approvalfilepath: result.approvalFilePath,
                            financialapprovalfilename: result.financialApprovalFileName, financialapprovalfilepath: result.financialApprovalFilePath,
                            workorderfilename: result.workOrderFileName, workorderfilepath: result.workOrderFilePath,
                            hamipatrafilename: result.hamiPatraFileName, hamipatrafilepath: result.hamiPatraFilePath,
                            revisionfilename: result.revisionFileName, revisionfilepath: result.revisionFilePath,
                            deliverable1: result.deliverable1, deliverable2: result.deliverable2, deliverable3: result.deliverable3,
                            deliverable4: result.deliverable4, deliverable5: result.deliverable5, deliverable6: result.deliverable6,
                            deliverable7: result.deliverable7, deliverable8: result.deliverable8, deliverable9: result.deliverable9,
                            deliverable10: result.deliverable10, sponsorshipamount: result.sponsorshipAmount,
                            revisedsponsorshipamount: result.revisedSponsorshipAmount,
                            deliverable1filename: result.deliverableFileName1, deliverable1filepath: result.deliverableFilePath1,
                            deliverable2filename: result.deliverableFileName2, deliverable2filepath: result.deliverableFilePath2,
                            deliverable3filename: result.deliverableFileName3, deliverable3filepath: result.deliverableFilePath3,
                            deliverable4filename: result.deliverableFileName4, deliverable4filepath: result.deliverableFilePath4,
                            deliverable5filename: result.deliverableFileName5, deliverable5filepath: result.deliverableFilePath5,
                            deliverable6filename: result.deliverableFileName6, deliverable6filepath: result.deliverableFilePath6,
                            deliverable7filename: result.deliverableFileName7, deliverable7filepath: result.deliverableFilePath7,
                            deliverable8filename: result.deliverableFileName8, deliverable8filepath: result.deliverableFilePath8,
                            deliverable9filename: result.deliverableFileName9, deliverable9filepath: result.deliverableFilePath9,
                            deliverable10filename: result.deliverableFileName10, deliverable10filepath: result.deliverableFilePath10,
                            completionfilename: result.completionFileName, completionfilepath: result.completionFilePath,
                            nastinumber: result.nastiNumber
                        });

                        const status = { value: 'Pending', label: 'Pending' };
                        setDeliverable1Status(result.deliverableStatus1 ? result.deliverableStatus1 : status);
                        setDeliverable2Status(result.deliverableStatus2 ? result.deliverableStatus2 : status);
                        setDeliverable3Status(result.deliverableStatus3 ? result.deliverableStatus3 : status);
                        setDeliverable4Status(result.deliverableStatus4 ? result.deliverableStatus4 : status);
                        setDeliverable5Status(result.deliverableStatus5 ? result.deliverableStatus5 : status);
                        setDeliverable6Status(result.deliverableStatus6 ? result.deliverableStatus6 : status);
                        setDeliverable7Status(result.deliverableStatus7 ? result.deliverableStatus7 : status);
                        setDeliverable8Status(result.deliverableStatus8 ? result.deliverableStatus8 : status);
                        setDeliverable9Status(result.deliverableStatus9 ? result.deliverableStatus9 : status);
                        setDeliverable10Status(result.deliverableStatus10 ? result.deliverableStatus10 : status);


                        setPresentationStatus(result.presentationStatus ? result.presentationStatus : status);
                        if (result.presentationDate === null) {
                            setPresentationDate(new Date());
                        }
                        else {
                            setPresentationDate(new Date(result.presentationDate));
                        }

                        if (result.proposalDate === null) {
                            setProposalDate(new Date());
                        }
                        else {
                            setProposalDate(new Date(result.proposalDate));
                        }

                        if (result.approvalDate === null) {
                            setApprovalDate(new Date());
                        }
                        else {
                            setApprovalDate(new Date(result.approvalDate));
                        }

                        if (result.financialApprovalDate === null) {
                            setFinancialApprovalDate(new Date());
                        }
                        else {
                            setFinancialApprovalDate(new Date(result.financialApprovalDate));
                        }

                        if (result.workOrderDate === null) {
                            setWorkOrderDate(new Date());
                        }
                        else {
                            setWorkOrderDate(new Date(result.workOrderDate));
                        }

                        if (result.revisionDate === null) {
                            setRevisionDate(new Date());
                        }
                        else {
                            setRevisionDate(new Date(result.revisionDate));
                        }
                    }
                    else {
                        // eslint-disable-next-line
                        alert(result.message.message);
                    }
                });
        }
        setLoading(false);
    };

    useEffect(() => {
        if (params.id > 0) {
            getRegistrationById();
        }
    }, []);

    const changeHandler = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    };

    const presnetationStatusChangeHandler = (ev) => {
        setPresentationStatus(ev);
    }

    const deliverable1StatusChangeHandler = (ev) => {
        setDeliverable1Status(ev);
    }
    const deliverable2StatusChangeHandler = (ev) => {
        setDeliverable2Status(ev);
    }
    const deliverable3StatusChangeHandler = (ev) => {
        setDeliverable3Status(ev);
    }
    const deliverable4StatusChangeHandler = (ev) => {
        setDeliverable4Status(ev);
    }
    const deliverable5StatusChangeHandler = (ev) => {
        setDeliverable5Status(ev);
    }
    const deliverable6StatusChangeHandler = (ev) => {
        setDeliverable6Status(ev);
    }
    const deliverable7StatusChangeHandler = (ev) => {
        setDeliverable7Status(ev);
    }
    const deliverable8StatusChangeHandler = (ev) => {
        setDeliverable8Status(ev);
    }
    const deliverable9StatusChangeHandler = (ev) => {
        setDeliverable9Status(ev);
    }
    const deliverable10StatusChangeHandler = (ev) => {
        setDeliverable10Status(ev);
    }

    const handleDownload = (fileName, filePath) => {
        setLoading(true);
        const formData = new FormData();
        formData.append("FileName", fileName);
        formData.append("FilePath", filePath);
        fetch(
            service.DOWNLOAD_FILE,
            {
                method: 'POST',
                headers: {
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                },
                body: formData
            })
            .then((response) => response.blob())
            .then((blob) => {
                // Create blob link to download
                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    fileName,
                );
                // Append to html link element page
                document.body.appendChild(link);
                // Start download
                link.click();
                // Clean up and remove the link
                link.parentNode.removeChild(link);
            });

        setLoading(false);
    };

    const backHandler = () => {
        navigate('/sponsorships');
    };

    function getExtension(filename) {
        return filename.split('.').pop()
    }

    const emailHandler = e => {
        e.preventDefault();
        const errs = {};
        setLoading(true);
        fetch(
            service.UPDATE_SPONSORSHIP_EMAIL_DETAILS,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                },
                body: JSON.stringify({
                    SponsorshipId: params.id,
                    EmailSent: 1
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result.messageType === 'Success') {
                    // eslint-disable-next-line
                    alert(result.message);
                    // navigate('/sponsorships');
                    window.location.reload();
                }
                else if (result.messageType === 'Failed') {
                    // eslint-disable-next-line
                    alert(result.message);
                    navigate('/sponsorships');
                }
                else {
                    errs[".invalid"] = result.message.message;
                    setErrors(errs);
                }
            });
        setLoading(false);
    };

    const saveHandler = e => {
        if (proposalFile && getExtension(proposalFile.name).toLowerCase() !== 'pdf') {
            // eslint-disable-next-line
            alert("Please upload pdf file");
        }
        else if (approvalFile && getExtension(approvalFile.name).toLowerCase() !== 'pdf') {
            // eslint-disable-next-line
            alert("Please upload pdf file");
        }
        else if (financialApprovalFile && getExtension(financialApprovalFile.name).toLowerCase() !== 'pdf') {
            // eslint-disable-next-line
            alert("Please upload pdf file");
        }
        else if (workOrderFile && getExtension(workOrderFile.name).toLowerCase() !== 'pdf') {
            // eslint-disable-next-line
            alert("Please upload pdf file");
        }
        else if (hamipatraFile && getExtension(hamipatraFile.name).toLowerCase() !== 'pdf') {
            // eslint-disable-next-line
            alert("Please upload pdf file");
        }
        else if (revisionFile && getExtension(revisionFile.name).toLowerCase() !== 'pdf') {
            // eslint-disable-next-line
            alert("Please upload pdf file");
        }
        else if (deliverable1File && getExtension(deliverable1File.name).toLowerCase() !== 'pdf') {
            // eslint-disable-next-line
            alert("Please upload pdf file");
        }
        else if (deliverable2File && getExtension(deliverable2File.name).toLowerCase() !== 'pdf') {
            // eslint-disable-next-line
            alert("Please upload pdf file");
        }
        else if (deliverable3File && getExtension(deliverable3File.name).toLowerCase() !== 'pdf') {
            // eslint-disable-next-line
            alert("Please upload pdf file");
        }
        else if (deliverable4File && getExtension(deliverable4File.name).toLowerCase() !== 'pdf') {
            // eslint-disable-next-line
            alert("Please upload pdf file");
        }
        else if (deliverable5File && getExtension(deliverable5File.name).toLowerCase() !== 'pdf') {
            // eslint-disable-next-line
            alert("Please upload pdf file");
        }
        else if (deliverable6File && getExtension(deliverable6File.name).toLowerCase() !== 'pdf') {
            // eslint-disable-next-line
            alert("Please upload pdf file");
        }
        else if (deliverable7File && getExtension(deliverable7File.name).toLowerCase() !== 'pdf') {
            // eslint-disable-next-line
            alert("Please upload pdf file");
        }
        else if (deliverable8File && getExtension(deliverable8File.name).toLowerCase() !== 'pdf') {
            // eslint-disable-next-line
            alert("Please upload pdf file");
        }
        else if (deliverable9File && getExtension(deliverable9File.name).toLowerCase() !== 'pdf') {
            // eslint-disable-next-line
            alert("Please upload pdf file");
        }
        else if (deliverable10File && getExtension(deliverable10File.name).toLowerCase() !== 'pdf') {
            // eslint-disable-next-line
            alert("Please upload pdf file");
        }
        else if (completionFile && getExtension(completionFile.name).toLowerCase() !== 'pdf') {
            // eslint-disable-next-line
            alert("Please upload pdf file");
        }
        else {
            e.preventDefault();
            const errs = {};
            setLoading(true);

            const formData = new FormData();
            formData.append("SponsorshipId", params.id);
            formData.append("PresentationDate", (new Date(presentationDate)).toUTCString());
            formData.append("ProposalDate", (new Date(proposalDate)).toUTCString());
            formData.append("ApprovalDate", (new Date(approvalDate)).toUTCString());
            formData.append("FinancialApprovalDate", (new Date(financialApprovalDate)).toUTCString());
            formData.append("WorkOrderDate", (new Date(workOrderDate)).toUTCString());
            formData.append("PresentationStatus", presentationStatus.value ? presentationStatus.value : data.presentationStatus);
            formData.append("OutwardNo", state.outwardnumber);
            formData.append("InwardNo", state.inwardnumber);
            formData.append("FinancialInwardNo", state.financialinwardnumber);
            formData.append("WorkOrderNo", state.workordernumber);
            formData.append("DeliverableStatus1", deliverable1Status.value ? deliverable1Status.value : data.deliverableStatus1);
            formData.append("DeliverableStatus2", deliverable2Status.value ? deliverable2Status.value : data.deliverableStatus2);
            formData.append("DeliverableStatus3", deliverable3Status.value ? deliverable3Status.value : data.deliverableStatus3);
            formData.append("DeliverableStatus4", deliverable4Status.value ? deliverable4Status.value : data.deliverableStatus4);
            formData.append("DeliverableStatus5", deliverable5Status.value ? deliverable5Status.value : data.deliverableStatus5);
            formData.append("DeliverableStatus6", deliverable6Status.value ? deliverable6Status.value : data.deliverableStatus6);
            formData.append("DeliverableStatus7", deliverable7Status.value ? deliverable7Status.value : data.deliverableStatus7);
            formData.append("DeliverableStatus8", deliverable8Status.value ? deliverable8Status.value : data.deliverableStatus8);
            formData.append("DeliverableStatus9", deliverable9Status.value ? deliverable9Status.value : data.deliverableStatus9);
            formData.append("DeliverableStatus10", deliverable10Status.value ? deliverable10Status.value : data.deliverableStatus10);
            formData.append("ProposalFile", proposalFile);
            formData.append("ApprovalFile", approvalFile);
            formData.append("FinancialApprovalFile", financialApprovalFile);
            formData.append("WorkOrderFile", workOrderFile);
            formData.append("HamiPatraFile", hamipatraFile);
            formData.append("RevisionFile", revisionFile);
            formData.append("Deliverable1File", deliverable1File);
            formData.append("Deliverable2File", deliverable2File);
            formData.append("Deliverable3File", deliverable3File);
            formData.append("Deliverable4File", deliverable4File);
            formData.append("Deliverable5File", deliverable5File);
            formData.append("Deliverable6File", deliverable6File);
            formData.append("Deliverable7File", deliverable7File);
            formData.append("Deliverable8File", deliverable8File);
            formData.append("Deliverable9File", deliverable9File);
            formData.append("Deliverable10File", deliverable10File);
            formData.append("CompletionFile", completionFile);
            formData.append("Deliverable1", state.deliverable1);
            formData.append("Deliverable2", state.deliverable2);
            formData.append("Deliverable3", state.deliverable3);
            formData.append("Deliverable4", state.deliverable4);
            formData.append("Deliverable5", state.deliverable5);
            formData.append("Deliverable6", state.deliverable6);
            formData.append("Deliverable7", state.deliverable7);
            formData.append("Deliverable8", state.deliverable8);
            formData.append("Deliverable9", state.deliverable9);
            formData.append("Deliverable10", state.deliverable10);
            formData.append("SponsorshipAmount", state.sponsorshipamount);
            formData.append("RevisedSponsorshipAmount", state.revisedsponsorshipamount);
            formData.append("RevisionDate", (new Date(revisionDate)).toUTCString());
            formData.append("NastiNumber", state.nastinumber);
            // formData.append("AddedBy", JSON.parse(window.sessionStorage.getItem('userData')).userId);
            fetch(
                service.UPDATE_SPONSORSHIP_DETAILS,
                {
                    method: 'POST',
                    headers: {
                        'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                    },
                    body: formData
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        // eslint-disable-next-line
                        alert(result.message);
                        navigate('/sponsorships');
                    }
                    else if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                        navigate('/sponsorships');
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setErrors(errs);
                    }
                });
            setLoading(false);
        }
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Save Details
                                </MDTypography>
                            </MDBox>
                            <br />
                            <TableContainer component={Paper} style={{ width: '80%', alignSelf: 'center' }}>
                                <Table>
                                    <TableRow>
                                        <TableCell width="60%">
                                            <div style={{ fontWeight: 'bold' }}> Presentation Date </div>
                                            <DatePicker
                                                id="presentationDate"
                                                selected={presentationDate}
                                                onChange={date => setPresentationDate(date)}
                                                dateFormat="MM/dd/yyyy"
                                                tabIndex={0}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".presentationDate"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ fontWeight: 'bold' }}> Presentation Status </div>
                                            <div style={{ fontSize: '14px' }}>
                                                <Dropdown menuClassName='myMenuClassName' id="presentationStatus"
                                                    name="presentationStatus"
                                                    options={presentationStatusData}
                                                    value={presentationStatus}
                                                    onChange={presnetationStatusChangeHandler}
                                                    label="Presentation Status"
                                                />
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <div style={{ fontWeight: 'bold' }}> Proposal Date </div>
                                            <DatePicker
                                                id="proposalDate"
                                                selected={proposalDate}
                                                onChange={date => setProposalDate(date)}
                                                dateFormat="MM/dd/yyyy"
                                                tabIndex={0}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".proposalDate"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ fontWeight: 'bold' }}>Outward Number</div>
                                            <MDInput fullWidth value={state.outwardnumber || ''}
                                                name="outwardnumber"
                                                onChange={changeHandler}
                                                id="outwardnumber"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".outwardnumber"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <div style={{ fontWeight: 'bold' }}>Govt Admin Approval Date</div>
                                            <DatePicker
                                                id="approvalDate"
                                                selected={approvalDate}
                                                onChange={date => setApprovalDate(date)}
                                                dateFormat="MM/dd/yyyy"
                                                tabIndex={0}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".approvalDate"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ fontWeight: 'bold' }}>Admin Inward Number</div>
                                            <MDInput fullWidth value={state.inwardnumber || ''}
                                                name="inwardnumber"
                                                onChange={changeHandler}
                                                id="inwardnumber"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".inwardnumber"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <div style={{ fontWeight: 'bold' }}>Govt Financial Approval Date</div>
                                            <DatePicker
                                                id="financialApprovalDate"
                                                selected={financialApprovalDate}
                                                onChange={date => setFinancialApprovalDate(date)}
                                                dateFormat="MM/dd/yyyy"
                                                tabIndex={0}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".financialApprovalDate"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ fontWeight: 'bold' }}>Financial Inward Number</div>
                                            <MDInput fullWidth value={state.financialinwardnumber || ''}
                                                name="financialinwardnumber"
                                                onChange={changeHandler}
                                                id="financialinwardnumber"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".financialinwardnumber"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <div style={{ fontWeight: 'bold' }}>Work Order Date</div>
                                            <DatePicker
                                                id="workOrderDate"
                                                selected={workOrderDate}
                                                onChange={date => setWorkOrderDate(date)}
                                                dateFormat="MM/dd/yyyy"
                                                tabIndex={0}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".workOrderDate"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ fontWeight: 'bold' }}>Work Order Number</div>
                                            <MDInput fullWidth value={state.workordernumber || ''}
                                                name="workordernumber"
                                                onChange={changeHandler}
                                                id="workordernumber"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".workordernumber"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <div style={{ fontWeight: 'bold' }}>Upload Proposal File (File Size 5 MB)</div>
                                            <TextField
                                                id="proposalFile"
                                                type="file"
                                                onChange={ev => setProposalFile(ev.target.files[0])}
                                                style={{ width: 200 }}
                                                required
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".proposalFile"]}</div>
                                            {state.proposalfilename ?
                                                <MDButton onClick={() => handleDownload(state.proposalfilename, state.proposalfilepath)}>{state.proposalfilename}</MDButton>
                                                : null}
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ fontWeight: 'bold' }}>Upload Admin Approval File (File Size 5 MB)</div>
                                            <TextField
                                                id="approvalFile"
                                                type="file"
                                                onChange={ev => setApprovalFile(ev.target.files[0])}
                                                style={{ width: 200 }}
                                                required
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".approvalFile"]}</div>
                                            {state.approvalfilename ?
                                                <MDButton onClick={() => handleDownload(state.approvalfilename, state.approvalfilepath)}>{state.approvalfilename}</MDButton>
                                                : null}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <div style={{ fontWeight: 'bold' }}>Upload Financial Approval File (File Size 5 MB)</div>
                                            <TextField
                                                id="financialApprovalFile"
                                                type="file"
                                                onChange={ev => setFinancialApprovalFile(ev.target.files[0])}
                                                style={{ width: 200 }}
                                                required
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".financialApprovalFile"]}</div>
                                            {state.financialapprovalfilename ?
                                                <MDButton onClick={() => handleDownload(state.financialapprovalfilename, state.financialapprovalfilepath)}>{state.financialapprovalfilename}</MDButton>
                                                : null}
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ fontWeight: 'bold' }}>Upload Work Order File (File Size 5 MB)</div>
                                            <TextField
                                                id="workOrderFile"
                                                type="file"
                                                onChange={ev => setWorkOrderFile(ev.target.files[0])}
                                                style={{ width: 200 }}
                                                required
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".workOrderFile"]}</div>
                                            {state.workorderfilename ?
                                                <MDButton onClick={() => handleDownload(state.workorderfilename, state.workorderfilepath)}>{state.workorderfilename}</MDButton>
                                                : null}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <MDInput label="Sponsorship Amount"
                                                fullWidth value={state.sponsorshipamount || ''}
                                                name="sponsorshipamount"
                                                onChange={changeHandler}
                                                id="sponsorshipamount"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".sponsorshipamount"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <MDInput label="Revised Sponsorship Amount"
                                                fullWidth value={state.revisedsponsorshipamount || ''}
                                                name="revisedsponsorshipamount"
                                                onChange={changeHandler}
                                                id="revisedsponsorshipamount"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".revisedsponsorshipamount"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <div style={{ fontWeight: 'bold' }}>Revision Date</div>
                                            <DatePicker
                                                id="revisionDate"
                                                selected={revisionDate}
                                                onChange={date => setRevisionDate(date)}
                                                dateFormat="MM/dd/yyyy"
                                                tabIndex={0}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".revisionDate"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ fontWeight: 'bold' }}>Upload Revision File (File Size 5 MB)</div>
                                            <TextField
                                                id="revisionFile"
                                                type="file"
                                                onChange={ev => setRevisionFile(ev.target.files[0])}
                                                style={{ width: 200 }}
                                                required
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".revisionFile"]}</div>
                                            {state.revisionfilename ?
                                                <MDButton onClick={() => handleDownload(state.revisionfilename, state.revisionfilepath)}>{state.revisionfilename}</MDButton>
                                                : null}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <div style={{ fontWeight: 'bold' }}>Upload Undertaking/Hamipatra File (File Size 5 MB)</div>
                                            <TextField
                                                id="hamipatraFile"
                                                type="file"
                                                onChange={ev => setHamipatraFile(ev.target.files[0])}
                                                style={{ width: 200 }}
                                                required
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".hamipatraFile"]}</div>
                                            {state.hamipatrafilename ?
                                                <MDButton onClick={() => handleDownload(state.hamipatrafilename, state.hamipatrafilepath)}>{state.hamipatrafilename}</MDButton>
                                                : null}
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ fontWeight: 'bold' }}>Nasti Number</div>
                                            <MDInput fullWidth value={state.nastinumber || ''}
                                                name="nastinumber"
                                                onChange={changeHandler}
                                                id="nastinumber"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".nastinumber"]}</div>
                                        </TableCell>
                                    </TableRow>
                                </Table>
                                <Table>
                                    <TableRow>
                                        <TableCell style={{ fontSize: '14px', fontWeight: 'bold' }}>Deliverable</TableCell>
                                        <TableCell style={{ fontSize: '14px', fontWeight: 'bold' }}>Status</TableCell>
                                        <TableCell style={{ fontSize: '14px', fontWeight: 'bold' }}>File Upload</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <MDInput label="Deliverable 1"
                                                fullWidth value={state.deliverable1 || ''}
                                                name="deliverable1"
                                                onChange={changeHandler}
                                                id="deliverable1"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".deliverable1"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ fontSize: '14px' }}>
                                                <Dropdown menuClassName='myMenuClassName' id="deliverable1Status"
                                                    name="deliverable1Status"
                                                    options={deliverableStatusData}
                                                    value={deliverable1Status}
                                                    onChange={deliverable1StatusChangeHandler}
                                                    label="Deliverable Status"
                                                />
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                id="deliverable1File"
                                                type="file"
                                                onChange={ev => setDeliverable1File(ev.target.files[0])}
                                                style={{ width: 200 }}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".deliverable1File"]}</div>
                                            {state.deliverable1filename ?
                                                <MDButton onClick={() => handleDownload(state.deliverable1filename, state.deliverable1filepath)}>{state.deliverable1filename}</MDButton>
                                                : null}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <MDInput label="Deliverable 2"
                                                fullWidth value={state.deliverable2 || ''}
                                                name="deliverable2"
                                                onChange={changeHandler}
                                                id="deliverable2"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".deliverable2"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ fontSize: '14px' }}>
                                                <Dropdown menuClassName='myMenuClassName' id="deliverable2Status"
                                                    name="deliverable2Status"
                                                    options={deliverableStatusData}
                                                    value={deliverable2Status}
                                                    onChange={deliverable2StatusChangeHandler}
                                                    label="Deliverable Status"
                                                />
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                id="deliverable2File"
                                                type="file"
                                                onChange={ev => setDeliverable2File(ev.target.files[0])}
                                                style={{ width: 200 }}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".deliverable2File"]}</div>
                                            {state.deliverable2filename ?
                                                <MDButton onClick={() => handleDownload(state.deliverable2filename, state.deliverable2filepath)}>{state.deliverable2filename}</MDButton>
                                                : null}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <MDInput label="Deliverable 3"
                                                fullWidth value={state.deliverable3 || ''}
                                                name="deliverable3"
                                                onChange={changeHandler}
                                                id="deliverable3"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".deliverable3"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ fontSize: '14px' }}>
                                                <Dropdown menuClassName='myMenuClassName' id="deliverable3Status"
                                                    name="deliverable3Status"
                                                    options={deliverableStatusData}
                                                    value={deliverable3Status}
                                                    onChange={deliverable3StatusChangeHandler}
                                                    label="Deliverable Status"
                                                />
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                id="deliverable3File"
                                                type="file"
                                                onChange={ev => setDeliverable3File(ev.target.files[0])}
                                                style={{ width: 200 }}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".deliverable3File"]}</div>
                                            {state.deliverable3filename ?
                                                <MDButton onClick={() => handleDownload(state.deliverable3filename, state.deliverable3filepath)}>{state.deliverable3filename}</MDButton>
                                                : null}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <MDInput label="Deliverable 4"
                                                fullWidth value={state.deliverable4 || ''}
                                                name="deliverable4"
                                                onChange={changeHandler}
                                                id="deliverable4"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".deliverable4"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ fontSize: '14px' }}>
                                                <Dropdown menuClassName='myMenuClassName' id="deliverable4Status"
                                                    name="deliverable4Status"
                                                    options={deliverableStatusData}
                                                    value={deliverable4Status}
                                                    onChange={deliverable4StatusChangeHandler}
                                                    label="Deliverable Status"
                                                />
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                id="deliverable4File"
                                                type="file"
                                                onChange={ev => setDeliverable4File(ev.target.files[0])}
                                                style={{ width: 200 }}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".deliverable4File"]}</div>
                                            {state.deliverable4filename ?
                                                <MDButton onClick={() => handleDownload(state.deliverable4filename, state.deliverable4filepath)}>{state.deliverable4filename}</MDButton>
                                                : null}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <MDInput label="Deliverable 5"
                                                fullWidth value={state.deliverable5 || ''}
                                                name="deliverable5"
                                                onChange={changeHandler}
                                                id="deliverable5"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".deliverable5"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ fontSize: '14px' }}>
                                                <Dropdown menuClassName='myMenuClassName' id="deliverable5Status"
                                                    name="deliverable5Status"
                                                    options={deliverableStatusData}
                                                    value={deliverable5Status}
                                                    onChange={deliverable5StatusChangeHandler}
                                                    label="Deliverable Status"
                                                />
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                id="deliverable5File"
                                                type="file"
                                                onChange={ev => setDeliverable5File(ev.target.files[0])}
                                                style={{ width: 200 }}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".deliverable5File"]}</div>
                                            {state.deliverable5filename ?
                                                <MDButton onClick={() => handleDownload(state.deliverable5filename, state.deliverable5filepath)}>{state.deliverable5filename}</MDButton>
                                                : null}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <MDInput label="Deliverable 6"
                                                fullWidth value={state.deliverable6 || ''}
                                                name="deliverable6"
                                                onChange={changeHandler}
                                                id="deliverable6"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".deliverable6"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ fontSize: '14px' }}>
                                                <Dropdown menuClassName='myMenuClassName' id="deliverable6Status"
                                                    name="deliverable6Status"
                                                    options={deliverableStatusData}
                                                    value={deliverable6Status}
                                                    onChange={deliverable6StatusChangeHandler}
                                                    label="Deliverable Status"
                                                />
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                id="deliverable6File"
                                                type="file"
                                                onChange={ev => setDeliverable6File(ev.target.files[0])}
                                                style={{ width: 200 }}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".deliverable6File"]}</div>
                                            {state.deliverable6filename ?
                                                <MDButton onClick={() => handleDownload(state.deliverable6filename, state.deliverable6filepath)}>{state.deliverable6filename}</MDButton>
                                                : null}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <MDInput label="Deliverable 7"
                                                fullWidth value={state.deliverable7 || ''}
                                                name="deliverable7"
                                                onChange={changeHandler}
                                                id="deliverable7"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".deliverable7"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ fontSize: '14px' }}>
                                                <Dropdown menuClassName='myMenuClassName' id="deliverable7Status"
                                                    name="deliverable7Status"
                                                    options={deliverableStatusData}
                                                    value={deliverable7Status}
                                                    onChange={deliverable7StatusChangeHandler}
                                                    label="Deliverable Status"
                                                />
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                id="deliverable7File"
                                                type="file"
                                                onChange={ev => setDeliverable7File(ev.target.files[0])}
                                                style={{ width: 200 }}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".deliverable7File"]}</div>
                                            {state.deliverable7filename ?
                                                <MDButton onClick={() => handleDownload(state.deliverable7filename, state.deliverable7filepath)}>{state.deliverable7filename}</MDButton>
                                                : null}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <MDInput label="Deliverable 8"
                                                fullWidth value={state.deliverable8 || ''}
                                                name="deliverable8"
                                                onChange={changeHandler}
                                                id="deliverable8"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".deliverable8"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ fontSize: '14px' }}>
                                                <Dropdown menuClassName='myMenuClassName' id="deliverable8Status"
                                                    name="deliverable8Status"
                                                    options={deliverableStatusData}
                                                    value={deliverable8Status}
                                                    onChange={deliverable8StatusChangeHandler}
                                                    label="Deliverable Status"
                                                />
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                id="deliverable8File"
                                                type="file"
                                                onChange={ev => setDeliverable8File(ev.target.files[0])}
                                                style={{ width: 200 }}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".deliverable8File"]}</div>
                                            {state.deliverable8filename ?
                                                <MDButton onClick={() => handleDownload(state.deliverable8filename, state.deliverable8filepath)}>{state.deliverable8filename}</MDButton>
                                                : null}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <MDInput label="Deliverable 9"
                                                fullWidth value={state.deliverable9 || ''}
                                                name="deliverable9"
                                                onChange={changeHandler}
                                                id="deliverable9"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".deliverable9"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ fontSize: '14px' }}>
                                                <Dropdown menuClassName='myMenuClassName' id="deliverable9Status"
                                                    name="deliverable9Status"
                                                    options={deliverableStatusData}
                                                    value={deliverable9Status}
                                                    onChange={deliverable9StatusChangeHandler}
                                                    label="Deliverable Status"
                                                />
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                id="deliverable9File"
                                                type="file"
                                                onChange={ev => setDeliverable9File(ev.target.files[0])}
                                                style={{ width: 200 }}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".deliverable9File"]}</div>
                                            {state.deliverable9filename ?
                                                <MDButton onClick={() => handleDownload(state.deliverable9filename, state.deliverable9filepath)}>{state.deliverable9filename}</MDButton>
                                                : null}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <MDInput label="Deliverable 10"
                                                fullWidth value={state.deliverable10 || ''}
                                                name="deliverable10"
                                                onChange={changeHandler}
                                                id="deliverable10"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".deliverable10"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ fontSize: '14px' }}>
                                                <Dropdown menuClassName='myMenuClassName' id="deliverable10Status"
                                                    name="deliverable10Status"
                                                    options={deliverableStatusData}
                                                    value={deliverable10Status}
                                                    onChange={deliverable10StatusChangeHandler}
                                                    label="Deliverable Status"
                                                />
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                id="deliverable10File"
                                                type="file"
                                                onChange={ev => setDeliverable10File(ev.target.files[0])}
                                                style={{ width: 200 }}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".deliverable10File"]}</div>
                                            {state.deliverable10filename ?
                                                <MDButton onClick={() => handleDownload(state.deliverable10filename, state.deliverable10filepath)}>{state.deliverable10filename}</MDButton>
                                                : null}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ fontSize: '14px', fontWeight: 'bold' }}>Completion File</TableCell>
                                        <TableCell colSpan="2">
                                            <TextField
                                                id="completionFile"
                                                type="file"
                                                onChange={ev => setCompletionFile(ev.target.files[0])}
                                                style={{ width: 200 }}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".completionFile"]}</div>
                                            {state.completionfilename ?
                                                <MDButton onClick={() => handleDownload(state.completionfilename, state.completionfilepath)}>{state.completionfilename}</MDButton>
                                                : null}
                                        </TableCell>
                                    </TableRow>
                                </Table>
                            </TableContainer>
                            <TableContainer component={Paper} style={{ width: '80%', alignSelf: 'center' }}>
                                <Table>
                                    <TableRow>
                                        <TableCell>
                                            {loading ? <div
                                                heigth="20"
                                                width="20"
                                                color='grey'
                                                ariaLabel='loading'
                                            > Loadin ... </div> :
                                                <div>
                                                    <MDButton color="info" onClick={saveHandler}>
                                                        Save
                                                    </MDButton>
                                                </div>
                                            }
                                        </TableCell>
                                        <TableCell>
                                            <MDButton color="secondary" onClick={backHandler}>
                                                Back
                                            </MDButton>
                                        </TableCell>
                                    </TableRow>
                                </Table>
                            </TableContainer>
                            <br /><br />
                            <TableContainer component={Paper} style={{ width: '80%', alignSelf: 'center' }}>
                                <Table>
                                    <TableRow>
                                        <TableCell width="40%"><div style={{ fontWeight: 'bold' }}>Presentation Email Status</div></TableCell>
                                        <TableCell>
                                            <MDButton color="info" onClick={emailHandler}>
                                                Send Email
                                            </MDButton>
                                            {/* {!data.emailSent ? */}
                                            <div style={{ fontSize: '12px', color: 'red' }}>Please save Presentation Date before sending mail to the applicant</div>
                                            {/* : null} */}
                                            {data.emailSent ?
                                                <div style={{ fontSize: '12px', color: 'red' }}>Mail Sent On {moment(data.emailSentDate).format('DD/MM/YYYY')}</div>
                                                : null}
                                        </TableCell>
                                    </TableRow>
                                </Table>
                            </TableContainer>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default SponsorshipWorkOrder;